/*-------------------------------------------------------------------

Creek Components:

  - Shows Page
    - Shows Nav (Weekdays, All Shows, Calendar, etc.)
    - Show on Shows Page
  - Show Page
  - Schedule Page (the calendar grid)
  - Broadcast Page
  - Profile Page

Notes:

- These are Vue.js components.
- Each "Page" is component for a Vue Router route.

-------------------------------------------------------------------*/

//Public modules from npm
var $ = require('jquery'); // !!! Don't use jQuery
var fecha = require('fecha'); // Date parsing (smaller than Moment.js)

//Local modules
var util = require('./creek-util');
var debug = require('./creek-debug').init().log;
var lang = require('./lang/eng'); 

//------------------------------------------------------------
//------------------------------------------------------------
//------------------------------------------------------------
// These functions below need to be converted to Vue methods.
//------------------------------------------------------------
//------------------------------------------------------------
//------------------------------------------------------------

var creekOptions = require('./creek-data').init({});

Creek.getWeekdayNumberForToday = function() {
  
  // console.log("TIME: "+fecha.format(new Date(), 'HH:mm:ss YY/MM/DD'))
  // console.log("TIME WEEKDAY: "+fecha.format(new Date(), 'd HH:mm:ss YYYY-MM-DD'))

  var weekday = parseInt(fecha.format(new Date(), 'd'));

  if(weekday === 0){
    weekday = 7;
  }

  // console.log("TIME FIXED WEEKDAY: "+weekday)

  return weekday;
}
Creek.getBaseURL = function() {
  return Creek.data.content.baseURLForAPI;
}
Creek.refreshContent = function() {
  
  Creek.debug.log("Refreshing content (adding audio players, etc.)");

  if(typeof Creek.content != "undefined" && Creek.content.refresh != "undefined"){
    Creek.content.refresh();
    Creek.debug.log("Refreshed with Creek.content.refresh()");
  }
  else{
    Creek.debug.log("No Creek.content.refresh() function found.");
  }

}

//-------------------------------------------------------------------
// Vue Mixins: Added to each Creek component (below this mixins section)
//-------------------------------------------------------------------

var mixins = {

  //Add the Creek options from the parent scope
  creekOptions: {
    props: ['creekOptions'],
    data () {
      return {
        // creekOptions: null
      }
    },
    methods: {
      creekOptionsUpdate (optionKey, optionValue) {
        //!!! TODO: emit event to update the parent Creek option
      }
    }
  },

  routes: {
    data () {
      return { 
        baseURLForAPI: Creek.getBaseURL() 
      }
    },
    methods: {

      setTitle (title) {

        //Disable if disabled.
        if (!Creek.data.router.enableTitles) {
          return;
        }

        if (Creek.data.station.title) {
          var append = " - "+Creek.data.station.title;
        }
        else {
          var append = "";
        }

        $("head title").html(title+append);

      },

      swapPageClass (page) {

        $("body").removeClass (function (index, css) {
          return (css.match (/(^|\s)creek-page-\S+/g) || []).join(' ');
        });
        $("body").addClass("creek-page-"+page)

      },

      activateRoute () {

        debug("Activating Vue.js route.");

        console.log("yep");

      }

    }
  }
}

//--------------------------------------------------
// Vue Components: Shows, and related components.
//--------------------------------------------------

module.exports['creek-shows-nav'] = {
  // mixins: [mixins.creekOptions],
  template: require('./templates/shows-nav'),
  props: ['showsNavText', 'weekdaySelected'],
  data () { 
    debug("nav1");
    return {
      // showsNavText: {}
    }
  }
};

module.exports['creek-show'] = {
  // mixins: [mixins.creekOptions],
  template: require('./templates/show'),
  props: ['dataShow'],
  data () { 
    return {
      // dataShow: {}
    } 
  },
  methods: {
    getProfileURL (User) {
      return Creek.data.content.pathPrefix + '/profiles/' + User.username;
    },
    getShowURL () {
      return Creek.data.content.pathPrefix + Creek.data.content.showsPath + this.dataShow.short_name;
    },
    formatTime(time){

      var parsed = fecha.parse(time, 'HH:mm:ss');

      return fecha.format(parsed, 'h:mma');

    }
  }
};

module.exports['creek-page-shows'] = {
  mixins: [mixins.routes],
  // mixins: [mixins.creekOptions, mixins.routes],
  template: require('./templates/page-shows'), 
  data () {
    
    debug("yep");

    return {

      // TODO: GET FROM CREEK MAIN
      showsByWeekday: null,

      showsNavText: lang.schedule

    }

  },
  computed: {
    weekdayNumber (){
      if (typeof this.$route.params.weekday_number != 'undefined') {
        return this.$route.params.weekday_number;
      }
      else{
        return Creek.getWeekdayNumberForToday()
      }
    },
    showsForSelectedWeekday () {
      if (!this.showsByWeekday) {
        return [];
      }
      else if(this.weekdayNumber) {
        return this.showsByWeekday[this.weekdayNumber].programs;
      }
    } 
  },
  methods: {

    fetchData () {
      
      //Only get data if it doens't already exist
      if (this.showsByWeekday == null) {
        debug("Loading Vue.js route: show schedule");
        var parentThis = this;
        $.getJSON(this.baseURLForAPI+"/api/schedule?callback=?", function(jsonParsed) {
          parentThis.showsByWeekday = jsonParsed;
          // TODO: EMIT UP TO CREEK MAIN
          // parentThis.creekOptionsUpdate("data.shows.data", jsonParsed);
          // Creek.content.refresh();
        });
      }

      this.setTitle(util.capitalizeFirstLetter(Creek.data.router.showsName));
      this.swapPageClass("shows");

    }

  },
  created () {
    this.fetchData();
    debug("shows!");
  },
}

module.exports['creek-page-shows-schedule'] = {
  mixins: [mixins.routes],
  // mixins: [mixins.creekOptions, mixins.routes],
  template: require('./templates/page-shows-schedule'),
  data () { 
    return { 
      html: null, 
      title: null,
      showsNavText: lang.schedule,
    } 
  },
  created () {
    this.fetchData();
    console.log("Schedule component created.");
  },
  methods: {
    fetchData () {
      //Get data from schedule if it's already been retrieved
      if (!this.html) {
        var parentThis = this;
        $.getJSON(this.baseURLForAPI+"/shows/schedule?json_wrap=1&external=1&external_complete=1&callback=?", function(jsonParsed) {
          parentThis.html = util.fixLinks(jsonParsed.html)
          parentThis.title = jsonParsed.title;
          //TODO: Update parent Creek options
        });
      }
      this.setTitle("Schedule");
      this.swapPageClass("shows-schedule");
    }
  }
}

module.exports['creek-page-shows-calendar'] = {
  mixins: [mixins.routes],
  // mixins: [mixins.creekOptions, mixins.routes],
  template: require('./templates/page-shows-schedule'),
  data () { 
    return { 
      html: null, 
      title: null,
      showsNavText: lang.schedule,
    } 
  },
  created () {
    this.fetchData();
  },
  methods: {
    fetchData () {
      //Get data from schedule if it's already been retrieved
      if (!this.html) {
        var parentThis = this;
        $.getJSON(this.baseURLForAPI+"/shows/schedule?json_wrap=1&external=1&external_complete=1&callback=?", function(jsonParsed) {
          parentThis.html = util.fixLinks(jsonParsed.html)
          parentThis.title = jsonParsed.title;
          //TODO: Update parent Creek options
        });
      }
      this.setTitle("Shows Calendar");
      this.swapPageClass("shows-calendar");
    }
  }
}

module.exports['creek-page-shows-all'] = {
  mixins: [mixins.creekOptions, mixins.routes],
  template: require('./templates/page-shows-all'),
  data () {
    return {
      shows: null,
      findTerm: '',
      showsNavText: lang.schedule
    }
  },
  created () {
    this.fetchData();
  },
  computed:{
    showsFiltered: function(){
      if(this.findTerm){
        // var parentThis = this;
        var findTermLowerCase = this.findTerm.toLowerCase();
        var showsToFilter = this.shows.slice(0);
        // console.log(showsToFilter);
        var showsAreFiltered = showsToFilter.filter(function (el) {
          var title = el.title.toLowerCase();
          // console.log(findTermLowerCase);
          // console.log(title);
          // console.log(title.indexOf(findTermLowerCase));
          // console.log(title.indexOf(findTermLowerCase) > -1);
          return title.indexOf(findTermLowerCase) > -1;
        });
        // console.log(showsToFilter);
        // console.log("derp");
        return showsAreFiltered;
      }
      else{
        return this.shows;
      }
    }
  },
  methods: {
    fetchData () {
      //Get data from schedule if it's already been retrieved
      if (this.shows == null) {
        var parentThis = this;
        $.getJSON(this.baseURLForAPI+"/api/shows?callback=?", function(jsonParsed) {
          parentThis.shows = jsonParsed;
        });
      }
      this.setTitle("All Shows");
      this.swapPageClass("shows-all");
    }
  }
}

module.exports['creek-page-show'] = {
  mixins: [mixins.creekOptions, mixins.routes],
  template: require('./templates/page-content-default'),
  data () { 
    console.log("page show");
    return { 
      html: '', 
      title: ''
    } 
  },
  created () {
    this.fetchData();
  },
  methods: {
    fetchData () {
      debug("Received data for Show.");
      var parentThis = this;
      $.getJSON(this.baseURLForAPI+"/shows/"+this.$route.params.short_name+"?external=1&external_complete=1&callback=?", function(jsonParsed) {
        parentThis.html = util.fixLinks(jsonParsed.html);
        parentThis.setTitle(jsonParsed.title);
      })
      this.swapPageClass("show creek-page-show-"+this.$route.params.short_name);
    }
  }
};

module.exports['creek-page-broadcast'] = {
  mixins: [mixins.creekOptions, mixins.routes],
  template: require('./templates/page-content-default'),
  data () { 
    return { 
      html: '', 
      title: ''
    } 
  },
  created () {
    this.fetchData();
  },
  methods: {
    fetchData () {

      var apiURL = this.baseURLForAPI + "/broadcasts/" + this.$route.params.broadcast_id + "?json_wrap=1&external=1&external_complete=1&callback=?";

      debug("Loading Vue.js route from API: "+apiURL);

      var parentThis = this;

      $.getJSON(apiURL, function(jsonParsed) {

        parentThis.html = util.fixLinks(jsonParsed.html, "broadcast");

        parentThis.setTitle(jsonParsed.title);
        parentThis.swapPageClass("broadcast");

        // Adds audio players
        Creek.refreshContent();

        // //Run it again after 500ms...?
        // // !!! This is not reliable since it relies on time.
        setTimeout(function() {
          Creek.refreshContent();
        }, 500);

        //Run it again after 3000ms...?
        // !!! This is not reliable since it relies on time.
        // setTimeout(function() {
        //   Creek.refreshContent();
        // }, 3000);

      })

    }
  }

}
module.exports['creek-page-profile'] = {
  mixins: [mixins.creekOptions, mixins.routes],
  template: require('./templates/page-content-default'),
  // props: ['username'],
  data () { 
    return { 
      html: '', 
      title: '',
      // username: null
    } 
  },
  created () {
    this.fetchData();
  },
  methods: { 
    fetchData () {

      var parentThis = this;

      $.getJSON(this.baseURLForAPI+"/profiles/"+this.$route.params.username+"?json_wrap=1&external=1&external_complete=1&callback=?", function(jsonParsed) {

        parentThis.html = util.fixLinks(jsonParsed.html, "profile");

        // Creek.debug.log(jsonParsed);
        
        parentThis.setTitle(jsonParsed.title);
        parentThis.swapPageClass("profile");

      })

      this.activateRoute();

    }
  }
}



// WEBPACK FOOTER //
// ./src/creek-shows-components.js